import { IConferenceReminder } from '../../models/conference-reminders.models';

export const conferenceReminderMockData: IConferenceReminder = {
  conferenceId: 'conferenceId',
  emails: [],
  timetoBeSent: 1234,
};
